// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"c2f326f6","632":"5afaa7e8","679":"7778db08"}[chunkId] + ".chunk.js";
};